import { useMutation } from '@tanstack/react-query';
import { login } from 'api/auth';
import Button from 'components/Button';
import TextInput from 'components/Form/TextInput';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function Login() {

    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const { mutate, status } = useMutation({
        mutationFn: login,
        onSuccess: () => {
            return navigate('/')
        },
        onError: (error) => {
            console.log(error)
            if (error.response?.status === 400) {
                return setError('Email o password errati')
            }
            if (error.response?.status === 404) {
                return setError('Utente non trovato')
            }
        }
    });

    function onSubmitHandler(e) {
        e.preventDefault();

        const formData = {
            email: e.target.email.value,
            password: e.target.password.value,
            onlylogin: true
        }

        console.log(formData)

        return mutate({
            data: formData
        })
    }

    return (
        <>
            <div className={`fixed top-0 left-0 right-0 bottom-0 bg-verylight flex items-center justify-center overflow-auto`}>
                <div className='p-10 box-border'>
                    <div className='bg-white border border-light p-10 w-[400px] max-w-[94vw] rounded-sm'>
                        <img src="/images/opificioai-logo.png" alt="OpificioAI Logo" className='w-30 mx-auto mt-4'/>

                        <p className='pt-8 text-center'>
                            Benvenuto,<br/>Accedi con il tuo account
                        </p>

                        <form onSubmit={onSubmitHandler} className='pt-12 flex flex-col gap-4'>
                            <TextInput
                                label="Email"
                                type="text"
                                name="email"
                                placeholder="Email"
                                required
                            />
                            <TextInput
                                label="Password"
                                type="password"
                                name="password"
                                placeholder="Password"
                                required
                            />

                            {error && 
                                <p className='text-red-600 text-center mt-3'>{error}</p>
                            }

                            <div className='pt-4'>
                                <Button submit className='w-full'>{status === 'loading' ? 'Caricamento...' : 'Accedi'}</Button>
                            </div>
                        </form>
                    </div>

                    <p className='block text-center text-sm text-muted pt-6'>
                        Non hai un account? <Link to="/user/signup" className='text-black hover:underline'>Registrati</Link>
                    </p>
                </div>
            </div>
        </>
    )
}
